"use client";

import { ReactLenis } from "lenis/react";
import { useReducedMotion } from "framer-motion";
import { usePathname } from "next/navigation";

type SmoothScrollProps = {
  children: React.ReactNode;
};

/**
 * Applies Lenis smooth scrolling to the whole marketing site. Mounted once in
 * the root layout. Disables smoothing when the visitor prefers reduced motion.
 *
 * The Studio page builder (`/studio`) is an app surface with its own nested
 * scroll areas (the Puck editor panels). Lenis' root-level wheel hijacking
 * breaks native wheel scrolling inside those panels, so smooth scrolling is
 * disabled for the entire Studio.
 */
export function SmoothScroll({ children }: Readonly<SmoothScrollProps>) {
  const shouldReduceMotion = useReducedMotion();
  const pathname = usePathname();

  if (pathname?.startsWith("/studio")) {
    return <>{children}</>;
  }

  return (
    <ReactLenis
      root
      options={{
        duration: 1.2,
        smoothWheel: !shouldReduceMotion,
      }}
    >
      {children}
    </ReactLenis>
  );
}
